export default __webpack_public_path__ + "static/media/logo.0ea1b659.png";